const actions = {
  getVehicleMakes(context, request) {
    return new Promise((resolve, reject) => {
      context.getters.CxmApiClient.ProcessRequest(
        "POST",
        "/vehicle/makes/search",
        request,
        request.scope ? [request.scope] : []
      )
        .then(resp => {
          if (resp.data && resp.data.successful) resolve(resp.data);
          else reject(data);
        })
        .catch(resp => {
          reject(resp);
        });
    });
  },
  getVehicleMakeNames(context, request) {
    return new Promise((resolve, reject) => {
      context.getters.CxmApiClient.ProcessRequest(
        "POST",
        "/vehicle/makes/search_names",
        request,
        request.scope ? [request.scope] : []
      )
        .then(resp => {
          if (resp.data && resp.data.successful) resolve(resp.data);
          else reject(data);
        })
        .catch(resp => {
          reject(resp);
        });
    });
  },
  getVehicleModels(context, request) {
    return new Promise((resolve, reject) => {
      context.getters.CxmApiClient.ProcessRequest(
        "POST",
        "/vehicle/models/search",
        request,
        request.scope ? [request.scope] : []
      )
        .then(resp => {
          if (resp.data && resp.data.successful) resolve(resp.data);
          else reject(data);
        })
        .catch(resp => {
          reject(resp);
        });
    });
  },
  getVehicleModelNames(context, request) {
    return new Promise((resolve, reject) => {
      context.getters.CxmApiClient.ProcessRequest(
        "POST",
        "/vehicle/models/search_names",
        request,
        request.scope ? [request.scope] : []
      )
        .then(resp => {
          if (resp.data && resp.data.successful) resolve(resp.data);
          else reject(data);
        })
        .catch(resp => {
          reject(resp);
        });
    });
  },
  getVehicleTrims(context, request) {
    return new Promise((resolve, reject) => {
      context.getters.CxmApiClient.ProcessRequest(
        "POST",
        "/vehicle/trims/search",
        request,
        request.scope ? [request.scope] : []
      )
        .then(resp => {
          if (resp.data && resp.data.successful) resolve(resp.data);
          else reject(data);
        })
        .catch(resp => {
          reject(resp);
        });
    });
  },
  getVehicleTrimNames(context, request) {
    return new Promise((resolve, reject) => {
      context.getters.CxmApiClient.ProcessRequest(
        "POST",
        "/vehicle/trims/search_names",
        request,
        request.scope ? [request.scope] : []
      )
        .then(resp => {
          if (resp.data && resp.data.successful) resolve(resp.data);
          else reject(data);
        })
        .catch(resp => {
          reject(resp);
        });
    });
  },
  getVehicleColorsByTrimId(context, request) {
    return new Promise((resolve, reject) => {
      context.getters.CxmApiClient.ProcessRequest(
        "POST",
        "/vehicle/trims/color",
        request,
        request.scope ? [request.scope] : []
      )
        .then(resp => {
          if (resp.data && resp.data.successful) resolve(resp.data);
          else reject(data);
        })
        .catch(resp => {
          reject(resp);
        });
    });
  }
};

export default {
  actions
};



// WEBPACK FOOTER //
// ./src/store/modules/Vehicle.js